export interface Equipment {
  vpCompanyID: number;
  name: string;
  equipmentIDs: string[];
  displayName: string;
  order: number;
}
